import AdminSalesforceSettings from './AdminSalesforceSettings';

export default AdminSalesforceSettings;
